import React, { useState, useEffect, useContext } from 'react';
import { Button, Card, Row, Col, Modal } from 'react-bootstrap';
import { DataContext } from '../../init/getData';
import { FaPlus } from 'react-icons/fa';
import Loader from '../../components/loader/loader';
import toast from 'react-hot-toast';


function LatestMembership() {
  const { api } = useContext(DataContext);
  const [isLoading, setIsLoading] = useState(false);
  const [membershipDetails, setMembershipDetails] = useState([]);
  const [barcodeInput, setBarcodeInput] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [fetchData, setFetchData] = useState(false);

  useEffect(() => {
    const fetchDataFromApi = async () => {
      if (!barcodeInput) {
        toast.error("Please enter a barcode.");
        return;  
      }

      try {
        setIsLoading(true);

        // Clear previous membership details before fetching
        setMembershipDetails([]);
        const response = await api.get('/newTransaction/getLatestMembership', { params: { barcode: barcodeInput } });
       
        if (response.data && !response.data.status) {
          console.log("No status or failed status:", response.data.message);
          toast.error(response.data.message || "Barcode does not exist.");
          return;
        }
        const memberships = response.data.data || [];

        // Ensure the numberOfAttendance is set even before any increment
        setMembershipDetails(memberships.map(detail => ({
          ...detail,
          numberOfAttendance: detail.numberOfAttendance || 0,
        })));

        const nonExpiredMemberships = memberships.filter(
          detail => new Date(detail.expiryDate) >= new Date()
        );

        if (nonExpiredMemberships.length > 0) {
          if (nonExpiredMemberships.length === 1) {
            // Automatically increment attendance if only one non-expired membership
            await incrementAttendance(nonExpiredMemberships[0].memberId, nonExpiredMemberships[0].classId);
          } else {
            // Show modal to let user choose which membership to increase attendance for
            setShowModal(true);
          }
        }
      } catch (error) {
        // Here we catch the Axios error, which is likely due to a 404 or other issues
        console.error("Error fetching membership details:", error);
        if (error.response && error.response.status === 404) {
          toast.error("Barcode does not exist.");
        } else {
          console.error("Failed to fetch data. Please try again later.");
        }
      } finally {
        setIsLoading(false);
      }
    };
  
    if (fetchData) {
      fetchDataFromApi();
      setFetchData(false);
    }
  }, [fetchData, barcodeInput, api]);  

  const handleBarcode = (e) => {
    if (e.key === 'Enter') {
      setFetchData(true);
      setBarcodeInput(e.target.value);
      e.target.value = '';
    }
  };

  const getStatusColor = (expiryDate) => {
    const expiry = new Date(expiryDate);
    return expiry >= new Date() ? 'lightgreen' : '#f8d7da';
  };

  const incrementAttendance = async (memberId, classId) => {
    try {
      await api.post('/newTransaction/incrementAttendance', { memberId, classId });
      setMembershipDetails(prevDetails =>
        prevDetails.map(detail =>
          detail.memberId === memberId && detail.classId === classId
            ? { ...detail, numberOfAttendance: detail.numberOfAttendance + 1 }
            : detail
        )
      );
    } catch (error) {
      console.error("Error incrementing attendance:", error);
    } finally {
      setShowModal(false);
    }
  };

  const handleModalClose = () => setShowModal(false);

  return (
    <div className="container">
      <input
        type="text"
        placeholder="Enter barcode"
        onKeyDown={handleBarcode}
        autoFocus
        className="form-control mb-3"
      />

      {isLoading ? (
        <div className="d-flex justify-content-center">
          <Loader />
        </div>
      ) : (
        <>
          <Row>
          {membershipDetails.length === 0 && !isLoading ? (
              <Col>
                <p className="text-center">No memberships found</p>
              </Col>
            ) : (
              membershipDetails.map(detail => (
                <Col md={4} key={detail.id} className="mb-3">
                  <Card
                    style={{ backgroundColor: getStatusColor(detail.expiryDate), minHeight: '250px' }}
                    onClick={() => incrementAttendance(detail.memberId, detail.classId)}
                  >
                    <Card.Body>
                      <Card.Title>{detail.class.name}</Card.Title>
                      <Card.Text>
                        <strong>Registration Date:</strong> {new Date(detail.registrationDate).toLocaleDateString()}<br />
                        <strong>Expiry Date:</strong> {new Date(detail.expiryDate).toLocaleDateString()}<br />
                        <strong>Balance:</strong> {detail.balance}<br />
                        <strong>Number of Attendance:</strong> {detail.numberOfAttendance}
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              ))
            )}
          </Row>

          {/* Modal for non-expired memberships */}
          <Modal show={showModal} onHide={handleModalClose}>
            <Modal.Header closeButton>
              <Modal.Title>Select Class to Increase Attendance</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row>
                {membershipDetails.filter(detail => new Date(detail.expiryDate) >= new Date()).map(detail => (
                  <Col key={detail.id} md={6} className="mb-3">
                    <Card
                      style={{ 
                        backgroundColor: '#f0f0f0',
                        cursor: 'pointer' 
                      }}
                      onClick={() => incrementAttendance(detail.memberId, detail.classId)} 
                    >
                      <Card.Body>
                        <Card.Title>{detail.class.name}</Card.Title>
                        <Card.Title>{detail.member.name}</Card.Title>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="danger" onClick={handleModalClose}>Close</Button>
            </Modal.Footer>
          </Modal>
        </>
      )}
    </div>
  );
}

export default LatestMembership;
